/** @format */

import React, { useState } from 'react';
import { Notification } from '../types/notification.type';

interface NotificationContextType {
    contextNotification: Notification[];
    setContextNotification: React.Dispatch<
        React.SetStateAction<Notification[]>
    >;
}

interface NotificationContextProviderProps {
    children: React.ReactNode;
}

export const NotificationContext = React.createContext<NotificationContextType>(
    {
        contextNotification: [],
        setContextNotification: () => {},
    },
);

export default function NotificationContextProvider({
    children,
}: NotificationContextProviderProps) {
    const [contextNotification, setContextNotification] = useState<
    Notification[]
    >([]);

    return (
        <NotificationContext.Provider
            value={{
                contextNotification,
                setContextNotification,
            }}>
            {children}
        </NotificationContext.Provider>
    );
}
